var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSagemakerNotebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c7b68;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Amazon-SageMaker_Notebook_light-bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Working"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.75,2.31V7.73H5.58v2H8.75v3.43H5.58v2H8.75v3.42H5.58v2H8.75V24H5.58v2H8.75v3.42H5.58v2H8.75v3.42H5.58v2H8.75v3.43H5.58v2H8.75v5.42H45.42V2.31ZM43.42,45.69H10.75V42.27h3.17v-2H10.75V36.84h3.17v-2H10.75V31.42h3.17v-2H10.75V26h3.17V24H10.75V20.58h3.17v-2H10.75V15.16h3.17v-2H10.75V9.73h3.17v-2H10.75V4.31H43.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.94,
    y: 14.3,
    width: 20.2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.94,
    y: 27.43,
    width: 10.1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.94,
    y: 7.73,
    width: 20.2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.94,
    y: 20.87,
    width: 20.2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSagemakerNotebookIcon);
export default __webpack_public_path__ + "static/media/sagemaker-notebook-icon.59a83463ee52cc7d57adaec91ac1eae7.svg";
export { ForwardRef as ReactComponent };